import styled from '@emotion/styled/macro';
import { Field } from 'formik';
import { Variables } from '../base/variables/variables';

/**
 * Relative import of `Variables`, not `@enter/core` — inside core that is a self-import, which
 * resolves to undefined at module init.
 */
export const Body = styled.div`
    display: flex;
    flex-direction: column;
    width: 480px;
    max-width: 100%;
`;

/** Scrolls on its own once addresses are added, so Cancel and Create stay in view. */
export const Fields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: 62vh;
    overflow-y: auto;
    padding: 0 24px 16px;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const Label = styled.label`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const FormField = styled(Field)`
    width: 100%;
    display: block;
`;

export const AddressGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border: 1px solid ${Variables.ThemeLight.Border1};
    border-radius: 6px;
`;

export const AddressHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 28px;
`;

export const AddressTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const Hint = styled.span`
    font-size: 13px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const AddressGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 12px;
`;

export const Cell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const WideCell = styled(Cell)`
    grid-column: 1 / -1;
`;

export const SmallLabel = styled.label`
    font-size: 13px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const AddRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 8px;
`;

export const Notice = styled.div`
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.Colors.n70};
    background: ${Variables.Colors.n5};
    border-radius: 4px;
    padding: 8px 12px;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 24px 24px;
    border-top: 1px solid ${Variables.Colors.n5};
`;
